import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@amzn/stencil-react-components/button';

// const ButtonLink = Button.withComponent(RouterLink);

// ButtonLink.defaultProps = {
//   ...ButtonLink.defaultProps,
//   flex: '100%',
//   flexDirection: 'row',
//   justifyContent: 'center',
//   alignSelf: 'center',
//   alignItems: 'center',
//   height: '100%',
// };

// export default ButtonLink;

const ButtonLink = React.forwardRef((props, ref) => {
  const { to, ...otherProps } = props;
  
  return (
    <Button
      {...otherProps}
      ref={ref}
      as={RouterLink}
      to={to}
    />
  );
});

ButtonLink.defaultProps = {
  flex: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignSelf: 'center',
  alignItems: 'center',
  height: '100%',
};

ButtonLink.displayName = 'ButtonLink';

export default ButtonLink;